export const IWCONFIG = {
  API_AUTHORIZE_ENDPOINT: process.env.REACT_APP_API_AUTHORIZE_ENDPOINT,
  API_AUTHORIZE_APP_SIG: process.env.REACT_APP_API_AUTHORIZE_APP_SIG,
  API_GET_FLIGHT_SCHEDULES: process.env.REACT_APP_API_FLIGHT_SCHEDULES,
  API_GET_PUBLIC_NOTICES: process.env.REACT_APP_API_PUBLIC_NOTICES,
  API_APP_ID: process.env.REACT_APP_API_APP_ID,
};

export default IWCONFIG;
